import { ConflictTagType } from "shared/form/renderer/enums/Conflict";
import { useCopies } from "shared/hooks/useCopies";

export function ConflictTag(props: { conflictTagType?: ConflictTagType }) {
  const copies = useCopies();
  switch (props.conflictTagType) {
    case ConflictTagType.NEW_VALUE:
      return <span className="newValueByUser--item">{copies.get("conflict.new.value.added")}</span>;
    case ConflictTagType.DELETED_VALUE:
      return <span className="removedValueByUser--item">{copies.get("conflict.existing.value.removed")}</span>;
    default:
      return null;
  }
}
